import { render, staticRenderFns } from "./AddrList.vue?vue&type=template&id=59be35e9&scoped=true&"
import script from "./AddrList.vue?vue&type=script&lang=js&"
export * from "./AddrList.vue?vue&type=script&lang=js&"
import style0 from "./AddrList.vue?vue&type=style&index=0&id=59be35e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be35e9",
  null
  
)

export default component.exports